document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const scope = select.closest('.product-info');
  const selected = select.options[select.selectedIndex];
  const price = scope.querySelector('[data-product-price]');
  const button = scope.querySelector('[data-add-to-cart]');
  if (price) price.textContent = selected.dataset.price;
  if (button && button.dataset.prelaunch !== 'true') {
    const available = selected.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to bag' : 'Sold out';
  }
});
